import { Component, Input } from '@angular/core';
import { LoadingController, NavController, NavParams } from 'ionic-angular';
import { DishServices } from "../../services";
import { DishIngredientsSelectPage } from "../../dish-create/dish-cost/dish-ingredients-select/dish-ingredients-select";
import { Globals } from "../../../../globals";
import { DishFoodcostPersonsPage } from '../dish-foodcost-persons/dish-foodcost-persons';
import { AddonsTriggerVersionProPage } from '../../../addons/addons-trigger-version-pro/addons-trigger-version-pro';

/**
 * Generated class for the DishViewListPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-dish-view-list',
  templateUrl: 'dish-view-list.html',
})
export class DishViewListPage {
  @Input() dish: any;

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public dishServices: DishServices,
    public loadingCtrl: LoadingController,
    public globals: Globals) {
  }

  edit() {
    if (this.globals.checkLimitsByLicense('dishes', 'foodcost')) {
      this.navCtrl.push(DishIngredientsSelectPage, {
        update: true,
        dish_uid: this.dish.UID,
        foodcost: this.dish.foodcost,
        foodcost_parts: this.dish.foodcost_parts,
        foodcost_static: this.dish.foodcost_static,
        dish_name: this.globals.nameLangSelectDish(this.dish),
        dish: this.dish
      });
    } else {
      this.navCtrl.push(AddonsTriggerVersionProPage);
    }
  }

  foodcostPersons() {
    if (this.globals.checkLimitsByLicense('dishes', 'foodcost')) {
      this.navCtrl.push(DishFoodcostPersonsPage, {
        dish_uid: this.dish.UID,
        foodcost: this.dish.foodcost,
        foodcost_parts: this.dish.foodcost_parts,
        foodcost_static: this.dish.foodcost_static,
        dish_name: this.globals.nameLangSelectDish(this.dish),
        dish: this.dish,
      });
    } else {
      this.navCtrl.push(AddonsTriggerVersionProPage);
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/dish/dish-view/dish-view-list/dish-view-list.ts